import { render, staticRenderFns } from "./Installatori.vue?vue&type=template&id=3fc4b919&scoped=true&"
import script from "./Installatori.vue?vue&type=script&lang=js&"
export * from "./Installatori.vue?vue&type=script&lang=js&"
import style0 from "./Installatori.vue?vue&type=style&index=0&id=3fc4b919&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc4b919",
  null
  
)

export default component.exports